import React, { useEffect, useState } from 'react';
import { getNotification, updateNotification } from '../service/WfhAPI';

import { useNavigate } from 'react-router-dom';
import $ from 'jquery';

import { encryptStorage } from '../constant';

export default function NotificationTable({ notification }) {
    const navigate = useNavigate();

    const [notificationData, setnotificationData] = useState([]);

    useEffect(() => {
        if (notification !== undefined) {
            setnotificationData(notification);
            let filterShown = notification.filter((res) => res.shown == 1);
            if (filterShown.length > 1) {
                $('#notificationDot').addClass('badge-custom2 bg-danger rounded-circle');
            }
            if (filterShown.length == 0) {
                $('#notificationDot').removeClass('badge-custom2 bg-danger rounded-circle');
            }
        }

        // getNotification({ empId: encryptStorage.getItem('employeeId') }).then(response => {
        //     setnotificationData(response.data.ResponseData)
        //     if (response.data.count > 1) {
        //         $('#notificationDot').addClass('badge-custom2 bg-danger rounded-circle');
        //     }
        // })
    }, [notification]);

    // useEffect(() => {
    //     setnotificationData(notificationData)
    // }, [notificationData])

    const notificationClick = async (route, state, res) => {
        await updateNotification({ Id: res.id });
        let filterShown = notificationData.filter((res) => res.shown == 1);
        if (filterShown.length == 1 || filterShown.length == 0) {
            $('#notificationDot').removeClass('badge-custom2 bg-danger rounded-circle');
        }
        if (state) {
            if (state?.way == 'MyProfile') {
                window.location.href = `/profilecontainer?EmpId=${encryptStorage.getItem('employeeId')}&IsTeamMember=true`;
            } else {
                navigate(route, state);
            }
        } else {
            navigate(route);
            // window.location.href = route;
        }
    };

    const bind = () => {
        return notificationData?.map((res, index) => {
            // if(index> 210)
            {
                return (
                    <>
                        <div
                            onClick={() => {
                                notificationClick(res?.route, res?.state, res);
                            }}
                            className={
                                res?.shown == 1
                                    ? ` cursor d-flex align-items-center p-3 border-top w-100 notification-not-seen`
                                    : ` cursor d-flex align-items-center p-3 border-top w-100`
                            }
                        >
                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="notication-image" />
                            <div className="ms-2">
                                <a
                                    href={res.title === 'Offboard' || res.title === 'Feedback' ? `${res?.route}` : null}
                                    className=" mb-0 semibold-text font-12 mt-1"
                                >
                                    {res?.message}
                                </a>
                                {/* {res?.title == 'Touchbase' ?
                                <label className="mb-0 semibold-text font-12 mt-1">
                                    {res?.title}
                                </label> : null} */}
                                <label className="d-flex regular-text font-12 notification-durationlabel-color my-1">
                                    <span>
                                        <ul className="d-flex">
                                            <li className="notification-leave-color font-12 regular-text me-5">{res?.title}</li>
                                            <li className="notification-leave-color font-12 regular-text">By {res?.by}</li>
                                        </ul>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </>
                );
            }
        });
    };

    return (
        <>
            <label className="semibold-text font-14 p-3 w-100">Notifications</label>
            {bind()}
        </>
    );
}
